module.exports = __webpack_public_path__ + "static/media/status-bar-inverted.b2c07143.svg";